/* ButtonWithShortcut.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["shortcut", "children", "forceFocusRing", "buttonAutoFocusRing", "onClick"];
import "./ButtonWithShortcut.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment, useEffect, useMemo } from 'react';
import { bind } from 'bind-event-listener';
import DeprecatedButton from '@atlaskit/button';
import { browser } from '@atlaskit/editor-common/browser';
import { Shortcut } from '../Shortcut/Shortcut';
import { isKeyboardEventMatchShortcut } from './isKeyboardEventMatchShortcut';
var buttonAutoFocusRingFix = null;
var forceFocusRingStyles = null;
/**
 * Component that renders a button with an optional keyboard shortcut.
 *
 * It binds a keydown event listener to the document to trigger the `onClick` function
 * when the `shortcut` is pressed.
 */
export function ButtonWithShortcut(_ref) {
  var shortcut = _ref.shortcut,
    children = _ref.children,
    forceFocusRing = _ref.forceFocusRing,
    buttonAutoFocusRing = _ref.buttonAutoFocusRing,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    var listener = function listener(event) {
      if (shortcut !== null && shortcut !== void 0 && shortcut.common && isKeyboardEventMatchShortcut(event, shortcut.common)) {
        event.preventDefault();
        event.stopPropagation();
        onClick === null || onClick === void 0 || onClick();
      }
    };
    return bind(document, {
      type: 'keydown',
      listener: listener
    });
  }, [onClick, shortcut]);
  var content = useMemo(function () {
    if (!shortcut) {
      return /*#__PURE__*/React.createElement(Fragment, null, children);
    }
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", {
      "aria-keyshortcuts": browser.mac ? shortcut === null || shortcut === void 0 ? void 0 : shortcut.mac : shortcut === null || shortcut === void 0 ? void 0 : shortcut.windows
    }, children), /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement(Shortcut, {
      shortcut: shortcut
    })));
  }, [shortcut, children]);
  return /*#__PURE__*/React.createElement(DeprecatedButton
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
  , _extends({
    onClick: onClick
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, rest, {
    className: ax([forceFocusRing && "_7br812j9 _5wkdv77o", buttonAutoFocusRing && "_15y812j9 _2en4v77o"]),
    style: {
      "--_toyvsf": ix("2px solid ".concat("var(--ds-border-focused, #388BFF)"))
    }
  }), content);
}